import { Route, Switch, useLocation } from "#src/components/Router.tsx";
import { AdyenAlertBanner } from "#src/components/layout/AdyenAlertBanner.tsx";
import Loading from "#src/components/layout/Loading.tsx";
import Main from "#src/components/layout/Main.tsx";
import { useStore } from "#src/stores/Store.tsx";
import lazyImport from "#src/utils/lazyImport.ts";
import React from "react";

const Admin = lazyImport(() => import("#src/routes/admin/Admin.tsx"));
const SuperAdmin = lazyImport(
  () => import("#src/routes/superAdmin/SuperAdmin.tsx")
);
const Home = lazyImport(() => import("#src/routes/Home.tsx"));
const Welcome = lazyImport(() => import("#src/routes/Welcome.tsx"));
const FindDetail = lazyImport(() => import("#src/routes/FindDetail.tsx"));
const Login = lazyImport(() => import("#src/routes/Login.tsx"));
const McpConsent = lazyImport(() => import("#src/routes/McpConsent.tsx"));
const Email = lazyImport(() => import("#src/routes/cart/Email.tsx"));
const RegisterPassword = lazyImport(
  () => import("#src/routes/cart/Password.tsx")
);
const NewAccount = lazyImport(() => import("#src/routes/cart/NewAccount.tsx"));
const AccountDetails = lazyImport(
  () => import("#src/routes/cart/AccountDetails.tsx")
);
const ResetPassword = lazyImport(() => import("#src/routes/ResetPassword.tsx"));
const TermsOfService = lazyImport(
  () => import("#src/routes/TermsOfService.tsx")
);
const PrivacyPolicy = lazyImport(() => import("#src/routes/PrivacyPolicy.tsx"));
const CompleteRegistration = lazyImport(
  () => import("#src/routes/checkout/CompleteRegistration.tsx")
);
const RegistrationSuccess = lazyImport(
  () => import("#src/routes/checkout/RegistrationSuccess.tsx")
);
const InformationRequest = lazyImport(
  () => import("#src/routes/checkout/InformationRequest.tsx")
);
const CallbackStripe = lazyImport(
  () => import("#src/routes/CallbackStripe.tsx")
);
const Account = lazyImport(() => import("#src/routes/account/Account.tsx"));
const NoMatch = lazyImport(() => import("#src/routes/NoMatch.tsx"));
const Store = lazyImport(() => import("#src/routes/Store.tsx"));
const Explore = lazyImport(() => import("#src/routes/Explore.tsx"));
const Cart = lazyImport(() => import("#src/routes/cart/Cart.tsx"));
const Search = lazyImport(() => import("#src/routes/Search.tsx"));
const StartRegistration = lazyImport(
  () => import("#src/routes/StartRegistration.tsx")
);
const MeetSignup = lazyImport(() => import("#src/routes/MeetSignup.tsx"));
const ParticipantDetails = lazyImport(
  () => import("#src/routes/cart/ParticipantDetails.tsx")
);
const Code = lazyImport(() => import("#src/routes/Code.tsx"));
const Logout = lazyImport(() => import("#src/routes/Logout.tsx"));

interface Props {}

// const ssr = ["/login"];

export default function Body(_props: Props) {
  const store = useStore();
  const location = useLocation();

  return (
    <Main
      isSuperAdmin={store.user?.isSalesOrAbove}
      isViewingAs={Boolean(store.superAdmin)}
    >
      {store.organization?.stripeAlert &&
        store.isAdminArea &&
        !location.pathname.includes("/admin/bank") && <AdyenAlertBanner />}
      <React.Suspense fallback={<Loading delay={250} />}>
        <Switch>
          <Route exact path="/" component={Home} />
          <Route path="/welcome" component={Welcome} />
          <Route exact path="/find" component={StartRegistration} />
          <Route exact path="/find/:id" component={FindDetail} />
          <Route path="/login" component={Login} />
          <Route exact path="/mcp/consent" component={McpConsent} />
          <Route path="/logout" component={Logout} />
          <Route path="/code/:code" component={Code} />
          <Route path="/reset-password/:token" component={ResetPassword} />
          <Route exact path="/callback-stripe" component={CallbackStripe} />
          <Route
            path="/register/password"
            exact
            render={(props) => <RegisterPassword {...props} isRegister />}
          />
          <Route
            path="/register/new-password"
            exact
            render={(props) => <NewAccount {...props} isRegister />}
          />
          <Route
            path="/register/account-details"
            exact
            render={(props) => <AccountDetails {...props} isRegister />}
          />
          <Route
            exact
            path="/register/participant-details/:id"
            render={(props) => <ParticipantDetails {...props} isRegister />}
          />
          <Route
            path="/register/:id"
            exact
            render={(props) => <NewAccount {...props} isRegister />}
          />
          <Route
            exact
            path="/register"
            render={(props) => <Email {...props} isRegister />}
          />
          <Route exact path="/checkout" component={CompleteRegistration} />
          <Route path="/cart" component={Cart} />
          <Route
            exact
            path="/checkout/complete-registration"
            component={CompleteRegistration}
          />
          <Route
            exact
            path="/checkout/success"
            component={RegistrationSuccess}
          />
          <Route
            exact
            path="/checkout/information-request"
            component={InformationRequest}
          />
          <Route path="/account" component={Account} />
          <Route path="/admin" component={Admin} />
          <Route path="/super-admin" component={SuperAdmin} />
          <Route path="/terms-of-service" component={TermsOfService} />
          <Route path="/privacy-policy" component={PrivacyPolicy} />
          <Route path="/store" component={Store} />
          <Route path="/explore" component={Explore} />
          <Route path="/search" component={Search} />
          <Route path="/meets/:id" component={MeetSignup} />
          <Route path="/volunteers/:id" component={MeetSignup} />
          <Route component={NoMatch} />
        </Switch>
      </React.Suspense>
    </Main>
  );
}
